import { getLastItem } from '../../utils/array';

// list of exact URLs to hide navigation for
const hideNavigationForURLs = [
  '/checkout/address',
  '/checkout/payment',
  '/checkout/thank-you',
  '/login',
];

// list of URL prefixes to hide navigation for
// cart is in prefix check because it could either be /cart or /cart/edit/0
const hideNavigationForURLPrefixes = ['reset-password', 'cart'];

// list of URL suffixes to hide navigation for
const hideNavigationForURLSuffixes = ['customize'];

/**
 * Returns true if navigation (header / footer) should be rendered
 *
 * Navigation should be hidden for two sets of URLS.
 * hideNavigationForURLs are full exact URLs to match
 * hideNavigationForURLPrefixes are pattern based. If the URL starts with the given prefix, it is considered a match
 * @param {History} history
 * @returns Boolean
 */
const shouldShowNavigation = (history) => {
  // If current location is found in given list of exact URLs, hide navigation
  const hideExact =
    hideNavigationForURLs.indexOf(history?.location?.pathname) > -1;
  if (hideExact) return false;

  // If prefix of current location is found in given list of URL prefixes, hide navigation
  const prefix = history?.location?.pathname.split('/')[1];
  const hidePrefix = hideNavigationForURLPrefixes.indexOf(prefix) > -1;
  if (hidePrefix) return false;

  // If suffix of current location is found in given list of URL prefixes, hide navigation
  const suffix = getLastItem(history?.location?.pathname.split('/'));
  const hideSuffix = hideNavigationForURLSuffixes.indexOf(suffix) > -1;
  if (hideSuffix) return false;

  return true;
};

export default shouldShowNavigation;
